export const REQ_CHATBOT_TAB_TYPE = Object.freeze({
    SUPPORT: 'Support',
});


export const DEFAULT_BOT_MESSAGE =  `Hi I'm Luna an AI Assistant to answer any "how to" questions for Streams AI Admin.`;